const sidebarData = [
  { title: "Dashboard", path: "/dashboard" },
  // {
  //   title: "CMS",
  //   children: [
  //     { title: "Pages", path: "/cms/pages" },
  //     { title: "Menus", path: "/cms/menus" },
  //     { title: "Media Library", path: "/cms/media-library" },
  //   ],
  // },
  {
    title: "About the College",
    children: [
      { title: "History", path: "/about/history" },
      { title: "Vision & Mission", path: "/about/vision-mission" },
      { title: "College at a Glance", path: "/about/college-at-glance" },
      { title: "College Kulgeet", path: "/about/college-kulgeet" },
      { title: "Academic Heritage", path: "/about/academic-heritage" },
      { title: "Student Testimonial", path: "/media-contact/student-testimonial" },
      {
        title: "Governance",
        children: [
          { title: "Chairman", path: "/about/governance/chairman" },
          { title: "Vice Chairman", path: "/about/governance/vice-chairman" },
          { title: "Legal Head", path: "/about/governance/registrar" },
          { title: "Chief Proctor", path: "/about/governance/chief-proctor" },
          { title: "HR and Finance", path: "/about/governance/finance-officer" },
          { title: "Principal of College", path: "/about/governance/heads-of-departments" },
          { title: "Head of Department", path: "/about/governance/dean-students-welfare" },
        ],
      },
      {
        title: "Administrative Authorities",
        children: [
          // { title: "Director Ranking Cell", path: "/about/admin-authorities/director-ranking-cell" },
          { title: "Admission Cell", path: "/about/admin-authorities/admission-cell" },
          { title: "Hostel Administrators", path: "/about/admin-authorities/hostel-administrators" },
          { title: "Faculty Administrators", path: "/about/admin-authorities/faculty-administrators" },
          { title: "Proctorial Officials", path: "/about/admin-authorities/proctorial-officials" },
        ],
      },
      {
        title: "Committees",
        children: [
          // { title: "College Court", path: "/about/committees/college-court" },
          { title: "Executive Council", path: "/about/committees/executive-council" },
          { title: "Academic Council", path: "/about/committees/academic-council" },
          { title: "Finance Committee", path: "/about/committees/finance-committee" },
        ],
      },
    ],
  },
  {
    title: "Academics",
    children: [
      { title: "Faculty & Department", path: "/academics/faculty-department" },
      { title: "Academic Calendar", path: "/academics/academic-calendar" },
      {
        title: "Academic Programmes",
        children: [
          { title: "UG Programmes", path: "/academics/ug-programmes" },
          { title: "PG Programmes", path: "/academics/pg-programmes" },
          { title: "B.El.Ed. Programme", path: "/academics/admissions/bel-ed" },
          { title: "M.Ed. Programme", path: "/academics/admissions/med" },
          { title: "B.Ed. Programme", path: "/academics/admissions/bed" },
          { title: "B.P.Ed. / M.P.Ed. Programme", path: "/academics/admissions/bped-mped" },

        ]
      },
      {
        title: "Institute/Centre",
        children: [
          { title: "ONGC Centre of Advanced Studies", path: "/academics/institutes/ongc-centre" }
        ]
      },
      {
        title: "Admissions",
        children: [
          { title: "U.G. Programme", path: "/academics/admissions/ug" },
          { title: "P.G. Programme", path: "/academics/admissions/pg" },
          // { title: "LURNS", path: "/academics/admissions/lurns" },

        ]
      },
      {
        title: "Department at a Glance",
        children: [
          { title: "Syllabus", path: "/academics/department/syllabus" },
          { title: "Notices", path: "/academics/department/notices" },
          { title: "Time Tables", path: "/academics/department/time-tables" },
          { title: "Faculty Members", path: "/academics/department/faculty-members" },
        ]
      }
    ],
  },
  {
    title: "Examination",
    children: [
      { title: "Examination Links", path: "/examination/links" },
      { title: "Examination Schedule", path: "/examination/schedule" },
    ],
  },
  {
    title: "Facilities",
    children: [
      { title: "Placement Cell", path: "/facilities/placement-cell" },
      { title: "Canteens", path: "/facilities/canteens" },
      { title: "Student Hostels", path: "/facilities/student-hostels" },
      { title: "Indoor Sports", path: "/facilities/sports/indoor-sports" },
      { title: "Outdoor Sports", path: "/facilities/sports/outdoor-sports" },
      { title: "Happy Thinking Laboratory", path: "/facilities/happy-thinking-laboratory" },
      { title: "Gymnasium", path: "/facilities/sports/gymnasium" },
      { title: "Yoga", path: "/facilities/yoga" },
    ],
  },
  {
    title: "Library",
    children: [
      { title: "U.G. Library", path: "/library/ug-library" },
      { title: "P.G. Library", path: "/library/pg-library" },
    ],
  },
  {
    title: "Media",
    children: [
      { title: "College in News", path: "/media-contact/college-in-news" },
      { title: "Photo Gallery", path: "/media-contact/photo-gallery" },
      { title: "Banner Management", path: "/media-contact/banners" },
      { title: "Videos", path: "/media-contact/videos" },
      { title: "Press Release", path: "/media-contact/press-release" },
      // { title: "Notice", path: "/media-contact/notice" },
    ]
  },
  {
    title: "Careers",
    children: [
      { title: "Vacancies in College", path: "/media-contact/vacancies-in-college" },
      { title: "Recruitment Portal", path: "/media-contact/recruitment-portal" },
      // { title: "Result Notification", path: "/media-contact/result-notification" },
      { title: "Forms and Guidelines", path: "/media-contact/forms-guidelines" },
    ]
  },
  {
    title: "Contact",
    children: [
      { title: "Contact Directory", path: "/media-contact/contact/contact-directory" },
      { title: "Address/MAP", path: "/media-contact/contact/address-map" },
      { title: "Social media", path: "/media-contact/contact/social-media" },
      { title: "Popup Enquiries", path: "/media-contact/popup-enquiries" },
      { title: "Student Queries", path: "/media-contact/student-queries" },
    ]
  },
  // {
  //   title: "Settings",
  //   children: [
  //     // { title: "Site Settings", path: "/settings/site-settings" },
  //     { title: "User Management", path: "/settings/users" },
  //     { title: "Role Management", path: "/settings/roles" },
  //   ],
  // },
  {
    title: "Terms & Policies",
    children: [
      { title: "Terms & Conditions", path: "/terms-and-policies/terms-and-conditions" },
    ],
  },
];

export default sidebarData;
